import React from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import { formatNumber } from '~/utils/numbers';

import styles from '~/components/modals/modal.module.scss';

const LargeLawnModalForm = ({
  onSubmit,
  lawnSqFt,
  largeLawnThreshold,
  onClose,
}) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>That’s a lot of ground to cover!</h1>

      <p className={cx(styles.text, styles.centerAlign)}>
        At{' '}
        <strong className="highlight">
          {formatNumber(parseInt(lawnSqFt))} sq. ft
        </strong>{' '}
        your lawn is larger than our maximum plan coverage, which is currently{' '}
        <strong>{formatNumber(largeLawnThreshold)} sq. ft.</strong>{' '}
      </p>

      <div className={styles.buttons}>
        <Button
          onClick={() => onSubmit({ type: 'requestOrderAnyway' })}
          fullWidth
        >
          I'd like to order anyway
        </Button>
        <Button
          variant="link"
          fullWidth
          onClick={onClose}
          style={{ marginTop: '1rem' }}
        >
          I'd like to adjust my lawn size
        </Button>
      </div>
    </div>
  );
};

export default LargeLawnModalForm;
